(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('document-import', {
            parent: 'account',
            url: '/document-import',
            data: {
                authorities: [],
                pageTitle: 'global.menu.document-import'
            },
            views: {
                'content@': {
                    templateUrl: 'app/document-import/document-import.html',
                    controller: 'DocumentImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('document-import');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
